module.exports = __webpack_public_path__ + "img/08_L2.3bbd9871.svg";